import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import UsersTable from "./UsersTable";
import SelectedUser from "./SelectedUser";

const Users = (props) => {
  const [users, setUsers] = useState(props.users);
  const [selectedUser, setSelectedUser] = useState(props.users[0]);

  useEffect(() => {
    if (!selectedUser) return;

    setSelectedUser(users.find((user) => user.id === selectedUser.id));
  }, [users]);

  return (
    <div className="flex flex-start gap-24">
      <UsersTable
        users={users}
        setUsers={setUsers}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        userLimit={props.userLimit}
      />

      <SelectedUser
        users={users}
        setUsers={setUsers}
        selectedUser={selectedUser}
        allCourses={props.allCourses}
        allGroups={props.allGroups}
      />
    </div>
  );
};

Users.propTypes = {
  users: PropTypes.array,
  allCourses: PropTypes.array,
  allGroups: PropTypes.array,
  userLimit: PropTypes.number,
};

export default Users;
